module.exports = __webpack_public_path__ + "static/media/align-slash.af6117c8.svg";